import { Component } from 'react';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import I18n from 'I18n';

// @ts-expect-error No types yet
import { fromMoment, toMomentPortalTz } from 'UIComponents/core/SimpleDate';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UITimePicker from 'UIComponents/input/UITimePicker';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import shallowCompare from 'react-addons-shallow-compare';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MINUTE_IN_MILLISECONDS = 60000;
class DateTimeField extends Component {
  constructor(props) {
    super(props);
    this.onDateChange = this.onDateChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  getMoment() {
    const {
      value = null
    } = this.props;
    if (!value) return null;
    return I18n.moment.portalTz(value);
  }
  getDate(moment = this.getMoment()) {
    if (!moment) return null;
    return fromMoment(moment);
  }
  getMinutes(moment = this.getMoment()) {
    const {
      type
    } = this.props;
    if (!moment) return undefined;
    if (type !== FieldTypes.DATE_TIME) return 0;
    return (moment.valueOf() - moment.clone().startOf('day').valueOf()) / MINUTE_IN_MILLISECONDS;
  }
  getTimestamp(date, minutes) {
    return toMomentPortalTz(date).add(minutes, 'm').valueOf();
  }
  onDateChange(e) {
    const date = e.target.value;
    this.setDateAndMinutes(date, this.getMinutes());
  }
  onTimeChange(e) {
    const minutes = e.target.value;
    this.setDateAndMinutes(this.getDate(), minutes);
  }
  setDateAndMinutes(date, minutes) {
    const {
      value = null,
      onFieldChange = emptyFunction
    } = this.props;
    if (date) {
      const newVal = this.getTimestamp(date, minutes);
      if (value !== newVal && !isNaN(newVal)) {
        onFieldChange(newVal);
      }
    } else {
      onFieldChange(null);
    }
  }
  renderTimePicker(moment, date) {
    const {
      step = 30,
      type,
      readOnly = false,
      useOnDark
    } = this.props;
    if (type !== FieldTypes.DATE_TIME) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIBox, {
      className: "input-box m-left-2",
      grow: 1,
      children: /*#__PURE__*/_jsx(UITimePicker, {
        disabled: !date,
        interval: step,
        onChange: this.onTimeChange,
        readOnly: readOnly,
        use: useOnDark ? 'on-dark' : 'default',
        value: this.getMinutes(moment)
      })
    });
  }
  render() {
    const {
      className = null,
      error = false,
      readOnly = false,
      useOnDark
    } = this.props;
    const dateTimeClassName = classNames('cmv2-date-time-field', className);
    const moment = this.getMoment();
    const date = this.getDate(moment);
    return /*#__PURE__*/_jsxs(UIFlex, {
      className: dateTimeClassName,
      children: [/*#__PURE__*/_jsx(UIBox, {
        className: "input-box",
        grow: 1,
        children: /*#__PURE__*/_jsx(UIDateInput, {
          error: error,
          onChange: this.onDateChange,
          readOnly: readOnly,
          use: useOnDark ? 'on-dark' : 'default',
          value: date
        })
      }), this.renderTimePicker(moment, date)]
    });
  }
}
export default DateTimeField;